module.exports = __webpack_public_path__ + "static/media/api_object_full.163ca6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/api_object_full.png
// module id = 528
// module chunks = 0